import { postAnalyticsEvent } from 'analytics/common';

export const trackAgentAssistRecommendationFailure = async (error) => {
  const parsePointers = {};
  const params = { error };

  return await postAnalyticsEvent('AGENT_ASSIST_RECOMMENDATION_FAILURE', parsePointers, params);
};

export const trackAgentAssistUsefulnessCopied = async (macroText, messageId) => {
  const parsePointers = { messagePtr: messageId };
  const params = { choice: 'Macro Copied', macroText };

  return await postAnalyticsEvent('AGENT_ASSIST_USEFULNESS', parsePointers, params);
};

export const trackAgentAssistUsefulnessNotHelpful = async (macroText, messageId) => {
  const parsePointers = { messagePtr: messageId };
  const params = { choice: 'Not Helpful', macroText };

  return await postAnalyticsEvent('AGENT_ASSIST_USEFULNESS', parsePointers, params);
};

export const trackAgentAssistUsefulnessFailure = async (error) => {
  const parsePointers = {};
  const params = { error };

  return await postAnalyticsEvent('AGENT_ASSIST_USEFULNESS_FAILURE', parsePointers, params);
};
